export const MENSAJE_DEFAULT_ENVIO = `En TAXTIC, nos enorgullece presentar una propuesta diseñada especialmente para ti.

Estamos convencidos de que esta propuesta puede ayudarte a alcanzar tus objetivos de manera más eficiente y efectiva.`;

export const MENSAJE_DEFAULT_REENVIO = `Esperamos que hayas tenido la oportunidad de revisar nuestra propuesta anterior.

Nos gustaría recordarte que esta propuesta sigue disponible para tu consideración.`;
